import { IconName } from 'boxicons';
import type { CSSProperties } from 'react';

import './icon.css';
import { COLOURS } from '../../../utils/consts';

interface IconProps {
    name: IconName;
    id?: string;
    size?: string;
    color?: string;
    cursor?: 'default' | 'pointer';
    title?: string;
    className?: string;
    onClick?: (event: any) => void;
    onMouseEnter?: () => void;
    onMouseLeave?: () => void;
}

export default function Icon({
    name,
    size = '24px',
    color = COLOURS.BLACK,
    cursor = 'default',
    title,
    id,
    className,
    onClick,
    onMouseEnter,
    onMouseLeave,
}: IconProps) {
    const style = {
        fontSize: size,
        color,
        cursor,
        '--icon-size': size,
    } as CSSProperties;

    return (
        <i
            className={`bx ${name} ${className}`}
            id={id}
            style={style}
            title={title}
            onClick={onClick}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
        />
    );
}
